import { axios as $http } from 'cm'
import APIS from '../api'
import { getWithSign } from 'src/public-resource/libs/yiapiRequest.js'
import { getRunTime } from 'src/public-resource/libs/utils/index.js'
import { getPlatform } from 'src/frontend-lib/tools/getPlatform.js'
import Bridge from 'src/frontend-lib/lib/Bridge.js'
import PageNewTwo from './PageNewTwo'
const YIAPI_SITE = getRunTime('//yiapi.xinli001.com/')
const $platform = getPlatform()
let myBridge = new Bridge()
export default class PageNewOne {
  constructor() {
    this.page = 1
    this.count = 0 // 记录请求到的item总数。要和page一起重置。

    this.size = 3
    this.total = 0 // 后端返回的item总数
    this.pending = false
    this.itemList = []

    this.existOrderInfo = { has_not_pay_order: false }

    this.pageEl = document.querySelector('.page_new_1')

    this.renderHTML()
    setTimeout(() => {
      this.button = this.pageEl.querySelector('.xt-change-btn')
      this.fetchList()
      this.getDataBeforeQuestion()
      this.listenChangeButton()
      this.listenAskButton()
    }, 40) // 等html先渲染完
  }

  renderHTML() {
    let html = `
      <div class="next_div free">
        <p>免费提问</p>
        <img class="xt-arrow-icon" src="${require('../img/xt-arrow.png')}" alt="" />
      </div>
      <p class="fufei">心探付费问答</p>
      <p class="fufei-desc">心探教练是线上助人教练，在付费问答，教练一对一引导您解决自身困惑，获得个人成长。</p>
      <div class="xintan-list-wrp"></div>
      <div class="xt-change-btn">换一换</div>
    `
    const wrapper = this.pageEl.querySelector('.xt-new-inner')
    wrapper.insertAdjacentHTML('beforeend', html)
  }

  fetchList() {
    return getWithSign(`${YIAPI_SITE}v5/yi/get-psychic-coach-list.json`, {
      page: this.page,
      type: 'cantonal',
      size: this.size
    })
      .then(res => {
        const { code, data } = res.data
        if (code === 0) {
          this.itemList = data.list
          this.total = data.total
          this.count += this.itemList.length

          // 数据不足四条，隐藏“换一换”按钮
          if (this.total <= 3) {
            this.renderList(this.itemList)
            this.button.style.display = 'none'
            return
          }

          // 数据加载完毕了，需重置page和count
          if (this.count >= this.total) {
            this.renderList(this.itemList)
            this.page = 1
            this.count = 0
            return
          }

          this.renderList(this.itemList)
          this.page++
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  getDataBeforeQuestion() {
    $http
      .get(APIS.getDataBeforeQuestion, {
        params: {},
        disabledUnLoginInterceptors: true
      })
      .then(res => res.data)
      .then(res => {
        if (+res.code === 0) {
          this.existOrderInfo = res.data
          // if (this.existOrderInfo.question_quality_coupon_status) {
          //   window.toast('您已经参与过领取测评优惠券的活动。')
          // }
        }
      })
  }

  // tag格式："情绪,成长"
  genTag(tag) {
    tag = tag || ''

    let list = tag.split(',').map(v => '#' + v.trim())
    list = list.filter(v => !!v) // 去除空项

    return list.join('、') // 拼成 #情绪、#成长 的格式
  }

  renderList(itemList) {
    let listEl = ``
    itemList.forEach((item, index) => {
      const itemEl = `
        <li>
          <img class="xt-avatar" src="${item.avatar}" alt="">
          <div class="xt-content">
            <div class="xt-content-top">
              <p class="xt-name">${item.nickname}</p>
              <p class="xt-tag" style="${
                +item.tag_answer_count === 0 ? 'display:none' : ''
              }">精华回答数${item.tag_answer_count}个</p>
            </div>
            <div class="xt-content-middle">${item.self_introduction}</div>
            <div class="xt-content-bottom">${this.genTag(item.tag)}</div>
          </div>
          <div class="xt-tiwen next_div no-free" data-index="${index}">找ta提问</div>
        </li>
      `
      listEl += itemEl
    })
    let html = `<ul class="xintan-list">${listEl}</ul>`
    const xintanListWrapper = document.querySelector('.xintan-list-wrp')
    xintanListWrapper.innerHTML = '' //先清空后插入
    xintanListWrapper.insertAdjacentHTML('beforeend', html)
  }

  listenChangeButton() {
    this.button.addEventListener('click', async () => {
      if (this.pending) return // 防止重复点击
      this.pending = true
      window.yxl.stat.send({
        name: '答疑馆',
        properties: {
          行为: '点击',
          页面: '问答类型的选择页面',
          对象: '换一批'
        }
      })
      this.fetchList().finally(() => {
        this.pending = false
      })
    })
  }

  listenAskButton() {
    const wrapper = this.pageEl.querySelector('.xintan-list-wrp')
    wrapper.addEventListener('click', e => {
      // 事件代理，点击“找ta解读”
      const target = e.target
      let itemList = this.itemList
      if (
        target.classList.contains('next_div') &&
        target.classList.contains('no-free')
      ) {
        if (this.existOrderInfo.has_not_pay_order) {
          $('body').append(`
            <div class="existOrder">
              <div class="content">
                <p class="title">用户您好，系统发现您已有心探教练服务的订单。是否进入已有的提问？</p>
                <div class="btn">进入已有提问</div>
                <div class="btn">创建新的提问</div>
              </div>
            </div>
          `)
          let questionId = this.existOrderInfo.pay_order_data.question_id
          $('.existOrder .btn').on('click', function() {
            if ($(this).index() === 1) {
              window.removeUnloadHandler()
              let url = `${location.protocol}${getRunTime(
                `//static.xinli001.com/`
              )}msite/index.html#/heart-search/paid-qa-order/${questionId}`
              if ($platform.isYixinliApp) {
                myBridge.call('openWebView', {
                  url: url,
                  hideNavigationBar: 1,
                  isCurrentPageOpen: 1
                })
              } else {
                window.location.href = url
              }
            } else {
              $('.existOrder').remove()
              continueAsk()
            }
          })
        } else {
          continueAsk()
        }

        function continueAsk() {
          window.pageNewTwo = new PageNewTwo(
            itemList[JSON.parse(target.dataset.index)]
          )
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/ask/questionProcess/js/PageNewOne.js